import React, {useState} from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import Accordion from '../../../components/mazraeKit/accordion';
import { publicFaqs } from './faqData';

const Faq = () => {

  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader title={'سوالات پرتکرار'} preIcon="icon-nameArrow---Right" isActiveRightIcon />

      <div className="d-flex w-full flex-col  h-full overflow-y-scroll px-3">
        {publicFaqs.map((item, index) => (
          <EachItemAccordion title={item.title} body={item.body} key={index} />
        ))}
      </div>
      <MainFooter />
    </div>
  );
};

export default Faq;

// EachItemAccordion ================================================

interface EachItemAccordionProps {
  title: string;
  body: JSX.Element | string;
}

const EachItemAccordion = ({title, body}: EachItemAccordionProps) => {
  const [openAccordion, setOpenAccordion] = useState(false);
  return (
    // Single Accordion =============================================
    <Accordion
      headerClassName="!h-[56px] !text-md !text-gray-800"
      accordionTitle={title.toString()}
      setOpenAccordion={setOpenAccordion}
      openAccordion={openAccordion}
    >
      <p className="text-md font-Regular text-justify">{body}</p>
    </Accordion>
  );
};
